import { InMemoryCache } from 'apollo-cache-inmemory';

// Entities normalize under `<__typename>:<id>`, so two types that share a numeric id
// (e.g. a Location and a VRA reason) never overwrite each other. Objects without both
// fields are stored inline in their parent. Typename comes from the server, so
// redirects below must match it exactly (case-sensitive).
export const dataIdFromObject = o => (o.__typename && o.id ? `${o.__typename}:${o.id}` : null);

export const cacheRedirects = {
  Query: {
    // `Transaction` is the server's `graphql_name` for Schema::TransactionType.
    transaction: (_, args, { getCacheKey }) => getCacheKey({ __typename: 'Transaction', id: args.id }),
  },
};

export const createCache = () => new InMemoryCache({ dataIdFromObject, cacheRedirects });
